import { render } from "./ProductosPrioridad.vue?vue&type=template&id=183778b1"
import script from "./ProductosPrioridad.vue?vue&type=script&lang=js"
export * from "./ProductosPrioridad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__